import React from 'react';
import { observer } from 'mobx-react';
import { FieldSelector } from 'src/components/Flowsteps/PushData/Mapping/common';
import { TextField } from '@fluentui/react';
import { SubstitutionPicker } from 'src/components/base/fields/SubstitutionPicker';
import { useStyles } from './ConstantMappingEditor.styles';
import { DataField } from 'shared/providers/types';
import { RenderFieldEditorFunc } from 'src/v2/components/controls/editors/types';

export interface ConstantMappingEditorState {
  fieldName: string;
  constantValue: string;
}

interface ConstantMappingEditorProps {
  state: ConstantMappingEditorState;
  objectFields: DataField[];
  errorMessage?: string;
  renderEditorForType: RenderFieldEditorFunc;
}

export const ConstantMappingEditor: React.FC<ConstantMappingEditorProps> = observer((props) => {
  const { state, objectFields, errorMessage, renderEditorForType } = props;
  const styles = useStyles();

  const renderFieldEditor = () => {
    const selectedField = objectFields.find((field) => field.name === state.fieldName);
    if (!selectedField) {
      return null;
    }
    return renderEditorForType(selectedField, { value: state.constantValue, onChange: (value: any) => state.constantValue = value });
  }

  return (
    <div className={styles.constantMappingEditor}>
      <FieldSelector
        disabled={false}
        options={objectFields.map((field) => ({ key: field.name, text: field.label }))}
        selectedKey={state.fieldName}
        onChange={(item: any) => { state.fieldName = item.key; state.constantValue = '' }}
        errorMessage={errorMessage}
        placeholder={''}
      />
      <div className={styles.valueEdit}>
        {renderFieldEditor()}
      </div>
    </div>
  );
});
